<template>
	<div class="p-grid p-pb-6">
		<div class="p-col-12 p-pt-1 p-pb-1">
        <h2><a href="#/account">{{$t('preferences.title_parent')}}</a> <img class="p-pl-2 p-pr-2" src="assets/irinox/icons/arrow_breadcrumb.svg" :alt="$t('common.arrow_right')"/> {{$t('preferences.title')}}</h2>
        <div class="irinox-form p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-6">
                  <label for="ms">{{$t('preferences.measurement_type')}}</label>
                  <Dropdown id="ms" v-model="userdata.preferences['measurement_system']" :options="ms" optionLabel="name" optionValue="code" 
                    :placeholder="$t('preferences.measurement_type_ph')" />
              </div>
              <div class="p-field p-col-12 p-md-6">
                  <label for="hv">{{$t('preferences.hour_visualization')}}</label>
                  <Dropdown id="hv" v-model="userdata.preferences['hours_display_system']" :options="hv" optionLabel="name" optionValue="code" 
                    :placeholder="$t('preferences.hour_visualization_ph')" />
              </div>
              <!-- <div class="p-field p-col-12 p-md-6">
                  <label for="ms">{{$t('preferences.notifications')}}</label>
                  <MultiSelect v-model="userdata.preferences['notifications']" :options="noti" optionLabel="name" optionValue="code" 
                    :placeholder="$t('preferences.notifications_ph')" display="chip" />
              </div> -->
              <div v-if="emailReport.isAdmin || role.includes('SERVICE')" class="p-field p-col-12 p-md-6">
                  <label>{{$t('preferences.email_report')}}</label>
                  <div v-if="emailReport.isAdmin" class="p-grid p-ai-center p-my-2" style="height: 46px; line-height: 20px">
                    <div class="p-col">
                      {{$t('preferences.email_report_haccp')}}
                    </div>
                    <div class="p-col-fixed">
                      <InputSwitch v-model="userdata.preferences['haccp_report']" :aria-label="$t('preferences.email_report_haccp')"/>
                    </div>
                  </div>
                  <div v-if="emailReport.isAdmin" class="p-grid p-ai-center p-my-2" style="height: 46px; line-height: 20px">
                    <div class="p-col">
                      {{$t('preferences.email_report_appliance')}}
                    </div>
                    <div class="p-col-fixed">
                      <InputSwitch v-model="userdata.preferences['appliance_report']" :aria-label="$t('preferences.email_report_appliance')"/>
                    </div>
                  </div>
                  <div class="p-grid p-ai-center p-my-2" style="height: 46px; line-height: 20px">
                    <div class="p-col">
                      {{$t('preferences.offline_mail_notification')}}
                    </div>
                    <div class="p-col-fixed">
                      <InputSwitch v-model="userdata.preferences['offline_mail_notification']" :aria-label="$t('preferences.offline_mail_notification')" />
                    </div>
                  </div>
                  <div class="p-grid p-ai-center p-my-2" style="height: 46px; line-height: 20px">
                    <div class="p-col">
                      {{$t('preferences.alarm_mail_notification')}}
                    </div>
                    <div class="p-col-fixed">
                      <InputSwitch v-model="userdata.preferences['alarm_mail_notification']" :aria-label="$t('preferences.alarm_mail_notification')" />
                    </div>
                  </div>
              </div>
              <div v-if="emailReport.isAdmin || role.includes('SERVICE')" class="p-field p-col-12 p-md-6">
                  <label>{{$t('preferences.push_report')}}</label>
                  <div v-if="emailReport.isAdmin" class="p-grid p-ai-center p-my-2" style="height: 46px; line-height: 20px">
                    <div class="p-col">
                      {{$t('preferences.push_noti_info')}}
                    </div>
                    <div class="p-col-fixed">
                      <InputSwitch v-model="userdata.preferences['push_notification']" :aria-label="$t('preferences.push_noti_info')" />
                    </div>
                  </div>
              </div>
              <div class="p-field p-col-12 p-md-12 privacy">
                <label>{{$t('preferences.privacy_title')}}</label>
                <div v-html="$t('terms.incipit', { url: docMapping.privacy })"></div>
                <div class="p-field-checkbox p-my-1">
                  <Checkbox v-model="userdata.marketing" :binary="true" class="p-mr-2" :aria-label="$t('terms.marketing_new', { url: docMapping.privacy })"/>
                  <p v-html="$t('terms.marketing_new', { url: docMapping.privacy })"></p>
                </div>
              </div>
        </div>
		</div>
	</div>
  <div class="footer-toolbar">
      <Button :label="$t('userinfo.save_button')" autofocus @click="save(!v$.$invalid)" />
  </div>

  <IrinoxDialogDark :visible="successDialog" mode="success" :message="$t('userinfo.success_dialog')"
    :life="3000" @update:visible="successDialog = $event" />

  <IrinoxDialogDark :visible="errorDialog" mode="error" :message="$t('userinfo.error_dialog')"
    :life="3000" @update:visible="errorDialog = $event" />

  <IrinoxDialogDark :visible="blockingErrorDialog" mode="error" :message="$t('userinfo.error_dialog')"
    :life="0" @update:visible="blockingErrorDialog = $event" />

</template>

<script>
import AccountService from '../../service/AccountService';
import ApplianceService from '../../service/ApplianceService';
// import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import { mapGetters } from 'vuex';
import docsMapping from "../../../public/json/docs_mapping.json"

export default {
    components: {
        IrinoxDialogDark,
    },
    setup: () => ({ v$: useVuelidate() }),
    data() {
        return {
          userdata: { preferences: {} },
          ms: [{
            name: this.$t('preferences.ms.metric'),
            code: "metric"
          },{
            name: this.$t('preferences.ms.imperial'),
            code: "imperial"
          }],
          hv: [{
            name: '24',
            code: "24h"
          },{
            name: '12',
            code: "12h"
          }],
          docsMapping: docsMapping,
          // noti: [{
          //   name: this.$t('preferences.noti.alarms'),
          //   code: "alarm"
          // },{
          //   name: this.$t('preferences.noti.other'),
          //   code: "other"
          // }],
          submitted: false,
          successDialog: false,
          errorDialog: false,
          blockingErrorDialog: false,
          emailReport: {
            isAdmin: false
          }
        };
    },
    computed: {
        ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          role: 'userdata/role',
        }),
        docMapping: function() {
          if(this.$i18n.locale=='en-US') {
            return this.docsMapping['us'];
          }
          return this.docsMapping[this.$i18n.locale];
        }
    },
    validations() {
        return {
        }
    },
    created() {
      this.accountService = new AccountService();
      this.applianceService = new ApplianceService();
    },
    mounted() {
        this.getUserData();
        if(this.role === 'USER') {
          this.reloadAppliances();
        }
    },
    methods: {
      getUserData() {
        this.accountService.getUserinfo(this.personaltoken)
          .then(userinfo => {
            this.userdata = userinfo;
            this.$store.commit('userdata/updateUserinfo', userinfo);
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.blockingErrorDialog = true;
          });
      },
      reloadAppliances() {
        this.applianceService.getAppliances(this.personaltoken)
          .then((appliances) => {
            this.$store.commit('appliances/appliances', appliances);
            for(let i = 0; i<appliances.length; i++) {
              if(appliances[i].role==='ADMIN') {
                this.emailReport.isAdmin = true;
                break;
              }
            }
          })
          .catch(error => {
            console.error("ERROR "+error);
            this.errorDialog = true;
          });
      },
      save(isFormValid) {
        this.submitted = true;

        if (!isFormValid) {
          return;
        }

        let updateData = {};
        updateData.country = this.userdata.country;
        updateData.firstName = this.userdata.firstName;
        updateData.lastName = this.userdata.lastName;
        updateData.phone = this.userdata.phone;
        updateData.address = this.userdata.address;
        updateData.city = this.userdata.city;
        updateData.postalCode = this.userdata.postalCode;
        updateData.language = this.userdata.language;
        updateData.preferences = this.userdata.preferences;
        updateData.tos = this.userdata.tos;
        updateData.marketing = this.userdata.marketing;

        this.accountService.putUserinfo(this.personaltoken, updateData)
          .then(() => {
            this.successDialog = true;
            this.getUserData();
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.errorDialog = true;
          });
      }
    }
}
</script>

<style scoped>


.privacy p {
  line-height: 20px;
}

.privacy >>> a {
  text-decoration: underline;
}

</style>